import React from "react";

export const StarIcon = (): JSX.Element => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.94905 0.5L7.5414 4.66438C7.43949 6.56392 5.40128 8.02511 2.85351 8.24429L0 8.46347L2.64969 8.60959C5.29937 8.75571 7.43949 10.29 7.64331 12.1895L8.05095 16.5L8.4586 12.1895C8.66242 10.29 10.7006 8.75571 13.4522 8.60959L16 8.46347L13.0446 8.24429C10.4968 8.02511 8.56051 6.49086 8.35669 4.66438L7.94905 0.5Z"
                fill="#2BAF9F"
            />
        </svg>
    );
};
